var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select } from 'src/ui/components/Input/Select/Select';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { convertToNumber } from 'src/shared/helpers/stringHelpers';
import styles from './ResultsPerPage.module.scss';
import { NUMBER_100, NUMBER_25, NUMBER_250, NUMBER_50 } from 'src/shared/constants';
export var ResultsPerPage = function (props) {
    var i18n = props.i18n, resultsPerPage = props.resultsPerPage, disabled = props.disabled, onChange = props.onChange;
    var resultsPerPageText = getPropsByKeyPath(i18n, 'components.pagination.resultsPerPage.title');
    var options = [NUMBER_25, NUMBER_50, NUMBER_100, NUMBER_250].map(String);
    var handleSelect = function (newValue) {
        if (!newValue)
            return;
        onChange(convertToNumber(newValue));
    };
    if (disabled || !resultsPerPage) {
        return null;
    }
    return (_jsxs("div", __assign({ className: styles.resultsPerPageWrapper }, { children: [_jsx("p", __assign({ className: styles.resultsPerPageText }, { children: resultsPerPageText })), _jsx(Select, { options: options, multiple: false, value: resultsPerPage.toString(), onChange: handleSelect })] })));
};
